<div
  class="lg:hidden kiosk:block fixed right-0 left-0 bottom-0 w-full shadow shadow-top bg-white"
  [style.z-index]="index$ | async"
>
  <div *ngIf="errorMessages">
    <p
      class="text-error-700 font-base text-sm bg-error-50 px-4 py-3 mx-5 rounded mt-5"
      *ngFor="let message of errorMessages"
    >
      {{ message }}
    </p>
    <div *ngIf="missingLocationIdError">
      <p class="text-error-700 font-base text-sm bg-error-50 px-4 py-3 mx-5 rounded mt-5">
        {{ missingLocationIdError }}
      </p>
    </div>
    <div
      class="p-4 align-middle max-w-md mx-auto"
      [class.pb-7]="isNotched"
      *ngIf="
        (cartHasProduct$ | async) &&
        !(checkCartIsValidCallInProgress$ | async) &&
        (orderValidate$ | async) as orderValidate
      "
    >
      <app-button-atom
        *ngIf="!(basketId$ | async) && !!orderValidate[orderKeys.AvailablePaymentMethods].length"
        [label]="
          orderValidate[orderKeys.FinalPrice] === 0
            ? ('basket.payment_zero' | translate)
            : (goToPaymentButtonText | translate)
        "
        [type]="'primary'"
        [size]="'L'"
        (click)="goToPayment()"
        [disabled]="
          isGoToPaymentInProgress ||
          !!errorMessages.length ||
          !(orderHasProduct$ | async) ||
          (missingPhone$ | async) === true ||
          onSiteLocationIsMissing === true ||
          !!missingLocationIdError
        "
        [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : undefined"
      ></app-button-atom>
      <div *ngIf="orderValidate$ | async as orderValidate">
        <app-button-atom
          *ngIf="
            !!orderValidate[orderKeys.AvailablePaymentMethods].length &&
            (basketId$ | async) &&
            (basket$ | async)?.user.id === (userId$ | async)
          "
          [label]="'basket.payment' | translate"
          [type]="'primary'"
          [size]="'L'"
          (click)="confirmOrder()"
          [disabled]="
            isGoToPaymentInProgress ||
            !!errorMessages.length ||
            !(orderHasProduct$ | async) ||
            (missingPhone$ | async) === true ||
            !!missingLocationIdError
          "
          [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : undefined"
        ></app-button-atom>
        <app-button-atom
          *ngIf="
            !!orderValidate[orderKeys.AvailablePaymentMethods].length &&
            (basketId$ | async) &&
            (basket$ | async)?.user.id !== (userId$ | async)
          "
          [label]="'basket.validate-order' | translate"
          [type]="'primary'"
          [size]="'L'"
          (click)="confirmOrder()"
          [disabled]="
            isGoToPaymentInProgress ||
            !!errorMessages.length ||
            !(orderHasProduct$ | async) ||
            (missingPhone$ | async) === true ||
            !!missingLocationIdError
          "
          [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : undefined"
        ></app-button-atom>
      </div>
    </div>
    <div
      *ngIf="!(orderValidate$ | async) || (checkCartIsValidCallInProgress$ | async)"
      class="p-4 align-middle max-w-md mx-auto"
      [class.pb-7]="isNotched"
    >
      <app-button-atom
        [label]="'basket.payment' | translate"
        [type]="'primary'"
        [size]="'L'"
        [disabled]="true"
        [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : undefined"
      ></app-button-atom>
    </div>
  </div>
</div>
